// TODO: Move into `./common/environment`
// TODO: Add all environment variables here & update references

function invariant(condition: any, message: string): asserts condition {
  if (!condition) throw new Error(message);
}

invariant(process.env.DEPLOY_ENV, 'DEPLOY_ENV must be set');
invariant(
  process.env.CVNA_APP_ABSOLUTE_BASE_URL,
  'CVNA_APP_ABSOLUTE_BASE_URL must be set'
);
invariant(process.env.CVNA_APIK_BASE_URL, 'CVNA_APIK_BASE_URL must be set');
invariant(process.env.CVNA_APP_CDN_URL, 'CVNA_APP_CDN_URL must be set');
invariant(
  process.env.CVNA_APP_CDNBLOB_BASE_URL,
  'CVNA_APP_CDNBLOB_BASE_URL must be set'
);

export const environment = process.env.DEPLOY_ENV as 'dev' | 'test' | 'prod';

export const isLocalEnvironment = Boolean(process.env.IS_LOCAL);

export const isProd = environment === 'prod';

export const isNonProd = environment === 'dev' || environment === 'test';

const commonEnvironmentMapping = {
  dev: 'development',
  test: 'test',
  prod: 'production'
};

export const commonEnvironment: any = commonEnvironmentMapping[environment];

export const absoluteBaseUrl: string = isLocalEnvironment
  ? 'https://localhost.carvana.com'
  : process.env.CVNA_APP_ABSOLUTE_BASE_URL;

export const apikUrl = process.env.CVNA_APIK_BASE_URL;

export const assetsCdnUrl = process.env.CVNA_APP_CDN_URL;

export const blobCdnUrl = process.env.CVNA_APP_CDNBLOB_BASE_URL;

export const vexCdnUrl = 'https://vexgateway.fastly.carvana.io';
